import { inject } from 'inversify-props';
import IAuthService from '../services/IAuthService';
import { Notification } from '../helpers/Notification';

export class Environment {
    @inject() private authService: IAuthService;
    notification: Notification = new Notification();

    public IsProductionEnv(): boolean {
        return process.env.NODE_ENV && process.env.NODE_ENV === 'production'
    }

    public async GenerateGuid(nrofguids: number): Promise<any> {
        return new Promise((resolve, reject) => {
            //if (this.IsProductionEnv()) {
                this.authService.get('/api/environment/generateGuid?nrofguids=' + nrofguids).then(
                    response => {
                        resolve(response.data as string[]);
                    }
                ).catch(
                    error => {
                        this.notification.showSnackbar(error.response);
                        reject(error);
                    }
                )
        })
    }

    public GetEnvironmentVariables(variables: string[]): Promise<object> {
        return new Promise((resolve, reject) => {
            this.authService.post('/api/environment/getEnvironmentVairables', variables).then(
                response => {
                    resolve(response.data);
                }
            ).catch(
                error => {
                    this.notification.showSnackbar(error.response);
                    reject(error);
                }
            )
        })
    }
}
